import { SET_IS_ADMIN_AUTHENTICATED } from "../../redux/actions/action.types";

export default function authenticateAdmin(stateSetter: any, authStatus: boolean) {
  stateSetter({
    type: SET_IS_ADMIN_AUTHENTICATED,
    payload: authStatus,
  });
}
